import React, { useState, useEffect } from "react";
import {
  Table,
  Modal,
  message,
  Button,
  Popconfirm,
  Form,
  Col,
  Tooltip,
  Upload,
  Row,
  Tag,
} from "antd";
import {
  PlusOutlined,
  UploadOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import InspectionApi from "@api/inspectionnew";
import sysApi from "@api/sys";
import { dictApi } from "@api/newApi";
import SearchForm from "@components/SearchForm";
import HandleButton from "@components/HandleButton";
import { connect } from "react-redux";
import moment from "moment";
import { getStationData, toolMouseTip } from "@utils/common";
import AddModel from "./add";
import download from "@utils/download";
import "./style.scss";
const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 17 },
};
const runStatusAry = ["热备", "运行"];

const InspectionCom = (props) => {
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadBtn, setLoadBtn] = useState(false);
  const [data, setData] = useState([]); // 表格数据
  const [deleteVisible, setDelVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [uploadVisible, setUploadVisible] = useState(false);
  const [editTitle, setEditTitle] = useState("新建模版");
  const [rowParams, setRowParams] = useState({});
  const [detailVisible, setDetailVisible] = useState(false);
  const [detailInfo, setDetailInfo] = useState(false);
  const [searchParams, setSearchParams] = useState({
    pageNum: 1,
    pageSize: 10,
  });
  const [total, setTotal] = useState(0);
  const [templateList, setTemplateList] = useState([]);
  const [selectList, setSelectList] = useState([
    {
      attr: { allowClear: true },
      label: "状态:",
      name: "status",
      message: "请选择状态",
      options: [
        { title: "禁用", value: 0, checked: false },
        { title: "启用", value: 1, checked: false },
      ],
      span: 8,
      labelCol: 12,
    },
    {
      attr: { allowClear: true },
      label: "运行状态:",
      name: "runStatus",
      message: "请选择运行状态",
      options: [
        { title: "运行", value: "1", checked: false },
        { title: "热备", value: "0", checked: false },
      ],
      span: 8,
      labelCol: 12,
    },
    {
      attr: { allowClear: true },
      label: "模板类型:",
      name: "templateType",
      message: "请选择模板类型",
      options: [],
      span: 8,
      labelCol: 12,
    },
  ]);
  const [inputList] = useState([
    {
      label: "模板名称:",
      name: "templateName",
      message: "请输入模板名称",
      span: 8,
      labelCol: 12,
    },
  ]);
  const [stationData, setStationData] = useState([]);

  useEffect(() => {
    getStationList();
    getPatrolTemplateType();
  }, []);

  useEffect(() => {
    getListByPages();
  }, [searchParams]);

  const getPatrolTemplateType = () => {
    dictApi
      .selectWithClassifyKey({ classifyKey: "patrolTemplateType" })
      .then((res) => {
        if (res.status !== "0") return;
        setTemplateList(res.data);
        const arr = res.data.map((item) => {
          return {
            key: item.value,
            title: item.disName,
            value: item.value,
            checked: false,
          };
        });
        const index = selectList.findIndex(
          (item) => item.name === "templateType"
        );
        if (index > -1) {
          selectList[index].options = arr;
          setSelectList([...selectList]);
        }
      });
  };

  const getStationList = () => {
    let data = getStationData(
      props.userInfo.stationIds ? props.userInfo.stationIds : "-1",
      props.userInfo.stationAliasName
    );
    setStationData(data);
  };

  const getListByPages = () => {
    setLoading(true);
    InspectionApi.query({ ...searchParams }).then((res) => {
      setLoading(false);
      if (res.status == 0 && res.data) {
        setData(res.data.data || []);
        setTotal(res.data.total);
      }
    });
  };

  // 分页
  const handleTableChange = (pagination) => {
    let params = {
      ...searchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    };
    setSearchParams(params);
  };

  /**
   * 搜索
   * @param params
   */
  const search = (paramsObj) => {
    let params = {
      ...paramsObj,
      pageNum: 1,
      pageSize: 10,
      stationId: paramsObj.stationId && paramsObj.stationId * 1,
    };
    setSearchParams(params);
  };

  /**
   * 删除规则
   */
  const deletes = (id) => {
    setLoadBtn(true);
    InspectionApi.delete(id)
      .then((res) => {
        setLoadBtn(false);
        if (res.status == 0) {
          setDelVisible(false);
          message.success("删除成功！");
          getListByPages();
        }
      })
      .catch(() => {
        setLoadBtn(false);
      });
  };

  // 改变状态
  const handleConfirm = async (info) => {
    if (info.status === 0) {
      // 获取流程id
      const result = await sysApi.getFlowableId({
        dictType: "sw-flowable",
        dictKey: "patrol_template_status_enable",
      });
      if (result.status !== "0") return;
      const processId = result.data;
      InspectionApi.enable({ id: info.id, processId }).then((res) => {
        if (res.status === "0") {
          message.success("启用成功");
          getListByPages();
        }
      });
    } else {
      const result = await sysApi.getFlowableId({
        dictType: "sw-flowable",
        dictKey: "patrol_template_status_disable",
      });
      if (result.status !== "0") return;
      const processId = result.data;
      InspectionApi.disenable({ id: info.id, processId }).then((res) => {
        if (res.status === "0") {
          message.success("禁用成功");
          getListByPages();
        }
      });
    }
  };

  const showDetail = (id) => {
    InspectionApi.getInfo({ id }).then((res) => {
      if (res.status !== "0") return;
      const index = templateList.findIndex(
        (s) => s.value == res.data.templateType
      );
      if (index !== -1) {
        res.data.templateTypeStr = templateList[index].disName;
      }
      setDetailInfo(res.data);
      setDetailVisible(true);
    });
  };

  const btnList = [
    {
      title: "新增",
      type: "primary",
      icon: <PlusOutlined />,
      visible:
        props.userInfo.btnResources.indexOf("patrol:template:add") === -1
          ? false
          : true,
      onClick: () => {
        setRowParams({
          patrolTemplateItems: [
            {
              lowerLimit: "",
              itemContent: "",
              upperLimit: "",
              unit: "",
              numericFlag: null,
              safetyPerilFlag: "",
              runStatus: null,
              defectLevelId: null,
            },
          ],
        });
        setEditTitle("新建模版");
        setEditVisible(true);
      },
    },
    {
      title: "批量导入",
      style: { marginLeft: "10px" },
      type: "primary",
      visible:
        props.userInfo.btnResources.indexOf("patrol:template:batchImport") ===
        -1
          ? false
          : true,
      icon: <UploadOutlined />,
      onClick: () => {
        setUploadVisible(true);
      },
    },
    {
      title: "下载模板",
      style: { marginLeft: "10px" },
      type: "primary",
      visible: true,
      icon: <DownloadOutlined />,
      onClick: () => {
        InspectionApi.downloadTemplate().then((res) => {
          download(res, "巡检模板.xlsx");
        });
      },
    },
  ];

  const UploadPropsprops = {
    beforeUpload() {
      return false;
    },
    accpet: ".xls",
    action: "#",
    showUploadList: true,
    maxCount: 1,
    onChange(info) {
      const name = info.file.name;
      if (name.indexOf(".xls") < 0 && name.indexOf(".xlsx") < 0) {
        message.warning("所选文件的格式不正确！");
        setFileList([]);
        return false;
      }
      info.file.status = "done";
      setFileList([info.file]);
    },
    fileList,
    onRemove(file) {
      let f = fileList;
      const { uid } = file;
      const idx = fileList.findIndex((item) => item.uid == uid);
      f.splice(idx, 1);
      setFileList([...f]);
    },
  };

  const columns = [
    {
      title: "模版名称",
      dataIndex: "templateName",
      align: "center",
      key: "templateName",
      render: (_t) => toolMouseTip(_t, 10),
    },
    {
      title: "状态",
      dataIndex: "status",
      align: "center",
      key: "status",
      width: 200,
      render: (obj) => {
        if (obj == 0) {
          return <Tag color="#FF3819">禁用</Tag>;
        } else if (obj == 1) {
          return <Tag color="#87d068">启用</Tag>;
        }
      },
    },
    {
      title: "审批状态",
      dataIndex: "approvalStatus",
      align: "center",
      key: "approvalStatus",
      render: (val) => {
        if (val == 1) {
          return <Tag color="#2D99FF">审批中</Tag>;
        } else if (val == 2) {
          return <Tag color="#87d068">通过</Tag>;
        } else if (val == 3) {
          return <Tag color="#FF3819">拒绝</Tag>;
        } else {
          return "-";
        }
      },
    },
    {
      title: "创建时间",
      dataIndex: "createAt",
      align: "center",
      key: "createAt",
      render: (obj) => {
        if (obj) {
          return moment(obj).format("YYYY-MM-DD HH:mm:ss");
        }
      },
    },
    {
      title: "操作",
      key: "operation",
      width: 200,
      fixed: "right",
      align: "center",
      render: (obj, record) => {
        return (
          <>
            <Popconfirm
              title={`确定要${record.status === 0 ? "启用" : "禁用"}模版吗？`}
              onConfirm={() => handleConfirm(record)}
              okText="确定"
              cancelText="取消"
            >
              {props.userInfo.btnResources.indexOf("patrol:template:enable") !==
                -1 &&
                record.approvalStatus !== 1 &&
                record.status === 0 && (
                  <Button className="success" size="small" type="primary">
                    启用
                  </Button>
                )}
              {props.userInfo.btnResources.indexOf(
                "patrol:template:disable"
              ) !== -1 &&
                record.approvalStatus !== 1 &&
                record.status !== 0 && (
                  <Button className="deleteBtn" size="small" type="primary">
                    禁用
                  </Button>
                )}
            </Popconfirm>
            {props.userInfo.btnResources.indexOf("patrol:template:edit") !==
              -1 && (
              <Button
                style={{ marginLeft: "5px" }}
                className="worningBtn"
                onClick={() => {
                  InspectionApi.getInfo({ id: record.id }).then((res) => {
                    setEditTitle("编辑模板");
                    setRowParams({
                      patrolTemplateItems: res.data.patrolTemplateItemInfos,
                      ...res.data,
                    });
                    setEditVisible(true);
                  });
                }}
                size="small"
                type="primary"
              >
                编辑
              </Button>
            )}
            {props.userInfo.btnResources.indexOf("patrol:template:info") !==
              -1 && (
              <Button
                onClick={() => showDetail(record.id)}
                size="small"
                type="primary"
                style={{ marginLeft: 10 }}
              >
                详情
              </Button>
            )}
          </>
        );
      },
    },
  ];
  const submit = () => {
    form.validateFields().then((values) => {
      if (!values) {
        return;
      }
      if (fileList.length == 0) return message.error("文件格式有误！");
      const formData = new FormData();
      formData.append("file", fileList[0]);
      InspectionApi.batchImportTemplate(formData, {
        "Content-Type":
          "multipart/form-data; boundary=----WebKitFormBoundaryYmNa307cOmXILq7Z",
      }).then((res) => {
        if (res.status === "0") {
          message.success("上传成功");
          form.resetFields();
          setUploadVisible(false);
          setFileList(null);
          getListByPages();
        }
      });
    });
  };
  return (
    <div className="baseContent boundary">
      <div className="title">
        <div style={{ marginLeft: "24px" }}>
          <SearchForm
            searchParams={searchParams}
            span={6}
            selectList={selectList}
            inputList={inputList}
            onSearch={search}
          />
        </div>
        <HandleButton
          btnList={btnList}
          btnStyle={{ padding: "0 24px 20px", textAlign: "right" }}
        />
        <div>
          <Table
            className="Table"
            scroll={{ x: columns.length * 200 }}
            columns={columns}
            dataSource={data}
            rowKey={(record) => record.id}
            pagination={{
              current: searchParams.pageNum,
              pageSize: searchParams.pageSize,
              showQuickJumper: true,
              showSizeChanger: true,
              showTotal: (total) => `共${total}条数据`,
              total: total,
            }}
            onChange={handleTableChange}
            loading={loading}
          />
        </div>

        {deleteVisible && (
          <Modal
            title="删除站点"
            width={420}
            open={deleteVisible}
            onCancel={() => setDelVisible(false)}
            confirmLoading={loadBtn}
            onOk={() => deletes(rowParams.id)}
          >
            <div style={{ textAlign: "center", color: "red" }}>
              <p>{`确定要删除巡检模版【${rowParams.templateName}】吗？`}</p>
            </div>
          </Modal>
        )}
        {uploadVisible && (
          <Modal
            title="批量导入"
            width={620}
            open={uploadVisible}
            footer={[
              <Row key={"btn"} span={24}>
                <Button
                  key={1}
                  onClick={() => {
                    setUploadVisible(false);
                  }}
                  className="abuttons"
                >
                  <i className="iconfont iconfanhui"></i>&nbsp;&nbsp;取消
                </Button>
                <Button
                  key={2}
                  loading={loading}
                  onClick={submit}
                  className="abuttons"
                  type="primary"
                >
                  <i className="iconfont iconbaocun"></i>&nbsp;&nbsp;保存
                </Button>
              </Row>,
            ]}
          >
            <Form
              {...layout}
              layout="horizontal"
              form={form}
              style={{ marginTop: "20px" }}
            >
              <Col span={18}>
                <Form.Item
                  label="模版文件"
                  name="file"
                  rules={[{ required: true, message: "请选择文件!" }]}
                >
                  <Upload {...UploadPropsprops}>
                    {
                      <div className="upload-clk-area">
                        <Button type="primary">上传文件</Button>
                      </div>
                    }
                  </Upload>
                </Form.Item>
              </Col>
            </Form>
          </Modal>
        )}
        {editVisible && (
          <AddModel
            stationData={stationData}
            visible={editVisible}
            title={editTitle}
            formData={rowParams}
            templateList={templateList}
            cancel={(bool) => {
              setEditVisible(false);
              bool && getListByPages();
            }}
          />
        )}
        <Modal
          title="巡检模板详情"
          open={detailVisible}
          onOk={() => setDetailVisible(false)}
          onCancel={() => setDetailVisible(false)}
        >
          <div className="instru-detail">
            <div className="defect-detail-td">
              <div className="defect-detail-title">
                {detailInfo.templateName}
              </div>
              <div className="defect-detail-status">
                <Tag color={detailInfo.status ? "#87d068" : "#FF3819"}>
                  {" "}
                  {detailInfo.status ? "启用" : "禁用"}{" "}
                </Tag>
              </div>
            </div>
            <div className="defect-detail-bd">
              <div className="defect-detail-bd-item">
                <div className="defect-detail-item-lable">模板类型：</div>
                <div className="defect-detail-item-desc">
                  {detailInfo.templateTypeStr}
                </div>
              </div>
              <div className="defect-details-list">
                <div className="defect-details-list-item">
                  <div className="defect-details-list-item-td">
                    <div className="defect-detail-item-lable">巡检项：</div>
                  </div>
                  {detailInfo.patrolTemplateItemInfos &&
                    detailInfo.patrolTemplateItemInfos.length > 0 &&
                    detailInfo.patrolTemplateItemInfos.map((item) => {
                      return (
                        <div
                          className="defect-details-list-item-bd"
                          key={item.id}
                        >
                          <div className="defect-details-item-content">
                            <div className="defect-details-item-content-label">
                              巡检内容
                            </div>
                            <div className="defect-details-item-content-text">
                              <Tooltip placement="top" title={item.itemContent}>
                                {item.itemContent.length > 6
                                  ? item.itemContent.substring(0, 5) + "…"
                                  : item.itemContent}
                              </Tooltip>
                            </div>
                          </div>
                          <div className="defect-details-item-content">
                            <div className="defect-details-item-content-label">
                              填写数值
                            </div>
                            <div className="defect-details-item-content-text">
                              {item.numericFlag ? "是" : "否"}
                            </div>
                          </div>
                          <div className="defect-details-item-content">
                            <div className="defect-details-item-content-label">
                              安全隐患
                            </div>
                            <div className="defect-details-item-content-text">
                              {item.safetyPerilFlag ? "是" : "否"}
                            </div>
                          </div>
                          <div className="defect-details-item-content">
                            <div className="defect-details-item-content-label">
                              运行状态
                            </div>
                            <div className="defect-details-item-content-text">
                              {item.runStatus &&
                                item.runStatus.length === 1 &&
                                runStatusAry[item.runStatus[0]]}
                              {item.runStatus &&
                                item.runStatus.length === 2 &&
                                runStatusAry[item.runStatus[0]] +
                                  "," +
                                  runStatusAry[item.runStatus[1]]}
                            </div>
                          </div>
                          <div className="defect-details-item-content">
                            <div className="defect-details-item-content-label">
                              缺陷等级
                            </div>
                            <div className="defect-details-item-content-text">
                              {item.defectLevelName}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(InspectionCom);
